import { Router } from '@angular/router';
import { SettingsService } from './../../services/settings.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-compbar',
  templateUrl: './compbar.component.html',
  styleUrls: ['./compbar.component.scss']
})
export class CompbarComponent implements OnInit {
  @Input() companies;
  constructor(private settingService: SettingsService, private router: Router) { }

  ngOnInit() {
  }


  onChangeCompany(companyId: string, companyName: string){
     this.settingService.changeSettings({ currentCompany: companyId , currentCompanyName: companyName });
     this.router.navigate(['apps/media']);
  }

}







// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/layouts/compbar/compbar.component.ts